module.exports = __webpack_public_path__ + "static/media/Camada_2.faf6ea34.svg";